import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	showDivider: boolean;
};

export const EventRowSkeleton: FC<Props> = ({ showDivider }) => {
	const { iconSize, iconBoxSize, radii, spacingTokens, activity } = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={spacingTokens.md}
			px={spacingTokens.lg}
			py={spacingTokens.md}
			borderBottom={showDivider ? 1 : 0}
			borderColor="surface.border"
		>
			<Skeleton
				variant="rounded"
				width={iconBoxSize.md}
				height={iconBoxSize.md}
				animation="wave"
				sx={{ borderRadius: radii.lg, flexShrink: 0 }}
			/>
			<Stack flex={1} minWidth={0} gap={spacingTokens.xs}>
				<Skeleton variant="text" width="35%" height={14} animation="wave" />
				<Skeleton variant="text" width="65%" height={18} animation="wave" />
				<Skeleton variant="text" width="45%" height={14} animation="wave" />
			</Stack>
			<Skeleton
				variant="circular"
				width={iconSize.sm}
				height={iconSize.sm}
				animation="wave"
				sx={{ flexShrink: 0, mt: `${activity.eventRow.chevronOffset}px` }}
			/>
		</Stack>
	);
};
